import rawChanges from "../content/changes.json";
import rawClaims from "../content/claims.json";
import rawEntities from "../content/entities.json";
import { parseKnowledgeBase } from "./domain";

export const knowledgeBase = parseKnowledgeBase({
  claims: rawClaims,
  entities: rawEntities,
  changes: rawChanges,
});

